// Auto-generado por scripts/generateSvgComponents.cjs
// No editar manualmente
// Fecha de generación: 2025-11-16T16:36:07.096Z

import CheckIcon from './CheckIcon';
import LunaIcon from './LunaIcon';
import AbajoIcon from './AbajoIcon';
import AccionesIcon from './AccionesIcon';
import ActualizarIcon from './ActualizarIcon';
import AdelanteIcon from './AdelanteIcon';
import AdvertenciaIcon from './AdvertenciaIcon';
import AjustesIcon from './AjustesIcon';
import AppleBlancoIcon from './AppleBlancoIcon';
import AppleNegroIcon from './AppleNegroIcon';
import ArribaIcon from './ArribaIcon';
import ArrobaIcon from './ArrobaIcon';
import AtrasIcon from './AtrasIcon';
import BasureroIcon from './BasureroIcon';
import BloqueadoIcon from './BloqueadoIcon';
import CalendarioIcon from './CalendarioIcon';
import CamaraIcon from './CamaraIcon';
import CampanaIcon from './CampanaIcon';
import CantineroIcon from './CantineroIcon';
import CarpetaMasIcon from './CarpetaMasIcon';
import CarritoIcon from './CarritoIcon';
import CasaIcon from './CasaIcon';
import CerrarIcon from './CerrarIcon';
import ChromeIcon from './ChromeIcon';
import ClipIcon from './ClipIcon';
import CompartirFueraIcon from './CompartirFueraIcon';
import CompartirIcon from './CompartirIcon';
import ConfiguracionesIcon from './ConfiguracionesIcon';
import CorazonIcon from './CorazonIcon';
import CorrectoIcon from './CorrectoIcon';
import CubiertosIcon from './CubiertosIcon';
import CuidadoIcon from './CuidadoIcon';
import DivisaIcon from './DivisaIcon';
import EditarIcon from './EditarIcon';
import EquipoIcon from './EquipoIcon';
import EstrellaAmarillaIcon from './EstrellaAmarillaIcon';
import EstrellaIcon from './EstrellaIcon';
import EventosIcon from './EventosIcon';
import FacebookColorIcon from './FacebookColorIcon';
import FiltrosIcon from './FiltrosIcon';
import GoogleColorIcon from './GoogleColorIcon';
import GraficoIcon from './GraficoIcon';
import GrillaIcon from './GrillaIcon';
import GuardarIcon from './GuardarIcon';
import HerramientasIcon from './HerramientasIcon';
import IdiomaIcon from './IdiomaIcon';
import ImagenIcon from './ImagenIcon';
import InformacionIcon from './InformacionIcon';
import InstagramIcon from './InstagramIcon';
import InventarioIcon from './InventarioIcon';
import ListaIcon from './ListaIcon';
import LupaIcon from './LupaIcon';
import MasHorizontalIcon from './MasHorizontalIcon';
import MasUsuarioIcon from './MasUsuarioIcon';
import MasVerticalIcon from './MasVerticalIcon';
import MasIcon from './MasIcon';
import MenosIcon from './MenosIcon';
import MensajeIcon from './MensajeIcon';
import MenuIcon from './MenuIcon';
import MundoIcon from './MundoIcon';
import OjoCerradoIcon from './OjoCerradoIcon';
import OjoIcon from './OjoIcon';
import PanelIcon from './PanelIcon';
import PedidosIcon from './PedidosIcon';
import PreguntaIcon from './PreguntaIcon';
import QrIcon from './QrIcon';
import RelojIcon from './RelojIcon';
import SeguroIcon from './SeguroIcon';
import SignoDolarIcon from './SignoDolarIcon';
import SocialIcon from './SocialIcon';
import SolIcon from './SolIcon';
import SubirIcon from './SubirIcon';
import TarjetaCreditoIcon from './TarjetaCreditoIcon';
import TecladoIcon from './TecladoIcon';
import TelefonoIcon from './TelefonoIcon';
import TortaIcon from './TortaIcon';
import UbicacionIcon from './UbicacionIcon';
import UsuarioIcon from './UsuarioIcon';
import VasosIcon from './VasosIcon';

// Exports públicos
export { default as CheckIcon } from './CheckIcon';
export { default as LunaIcon } from './LunaIcon';
export { default as AbajoIcon } from './AbajoIcon';
export { default as AccionesIcon } from './AccionesIcon';
export { default as ActualizarIcon } from './ActualizarIcon';
export { default as AdelanteIcon } from './AdelanteIcon';
export { default as AdvertenciaIcon } from './AdvertenciaIcon';
export { default as AjustesIcon } from './AjustesIcon';
export { default as AppleBlancoIcon } from './AppleBlancoIcon';
export { default as AppleNegroIcon } from './AppleNegroIcon';
export { default as ArribaIcon } from './ArribaIcon';
export { default as ArrobaIcon } from './ArrobaIcon';
export { default as AtrasIcon } from './AtrasIcon';
export { default as BasureroIcon } from './BasureroIcon';
export { default as BloqueadoIcon } from './BloqueadoIcon';
export { default as CalendarioIcon } from './CalendarioIcon';
export { default as CamaraIcon } from './CamaraIcon';
export { default as CampanaIcon } from './CampanaIcon';
export { default as CantineroIcon } from './CantineroIcon';
export { default as CarpetaMasIcon } from './CarpetaMasIcon';
export { default as CarritoIcon } from './CarritoIcon';
export { default as CasaIcon } from './CasaIcon';
export { default as CerrarIcon } from './CerrarIcon';
export { default as ChromeIcon } from './ChromeIcon';
export { default as ClipIcon } from './ClipIcon';
export { default as CompartirFueraIcon } from './CompartirFueraIcon';
export { default as CompartirIcon } from './CompartirIcon';
export { default as ConfiguracionesIcon } from './ConfiguracionesIcon';
export { default as CorazonIcon } from './CorazonIcon';
export { default as CorrectoIcon } from './CorrectoIcon';
export { default as CubiertosIcon } from './CubiertosIcon';
export { default as CuidadoIcon } from './CuidadoIcon';
export { default as DivisaIcon } from './DivisaIcon';
export { default as EditarIcon } from './EditarIcon';
export { default as EquipoIcon } from './EquipoIcon';
export { default as EstrellaAmarillaIcon } from './EstrellaAmarillaIcon';
export { default as EstrellaIcon } from './EstrellaIcon';
export { default as EventosIcon } from './EventosIcon';
export { default as FacebookColorIcon } from './FacebookColorIcon';
export { default as FiltrosIcon } from './FiltrosIcon';
export { default as GoogleColorIcon } from './GoogleColorIcon';
export { default as GraficoIcon } from './GraficoIcon';
export { default as GrillaIcon } from './GrillaIcon';
export { default as GuardarIcon } from './GuardarIcon';
export { default as HerramientasIcon } from './HerramientasIcon';
export { default as IdiomaIcon } from './IdiomaIcon';
export { default as ImagenIcon } from './ImagenIcon';
export { default as InformacionIcon } from './InformacionIcon';
export { default as InstagramIcon } from './InstagramIcon';
export { default as InventarioIcon } from './InventarioIcon';
export { default as ListaIcon } from './ListaIcon';
export { default as LupaIcon } from './LupaIcon';
export { default as MasHorizontalIcon } from './MasHorizontalIcon';
export { default as MasUsuarioIcon } from './MasUsuarioIcon';
export { default as MasVerticalIcon } from './MasVerticalIcon';
export { default as MasIcon } from './MasIcon';
export { default as MenosIcon } from './MenosIcon';
export { default as MensajeIcon } from './MensajeIcon';
export { default as MenuIcon } from './MenuIcon';
export { default as MundoIcon } from './MundoIcon';
export { default as OjoCerradoIcon } from './OjoCerradoIcon';
export { default as OjoIcon } from './OjoIcon';
export { default as PanelIcon } from './PanelIcon';
export { default as PedidosIcon } from './PedidosIcon';
export { default as PreguntaIcon } from './PreguntaIcon';
export { default as QrIcon } from './QrIcon';
export { default as RelojIcon } from './RelojIcon';
export { default as SeguroIcon } from './SeguroIcon';
export { default as SignoDolarIcon } from './SignoDolarIcon';
export { default as SocialIcon } from './SocialIcon';
export { default as SolIcon } from './SolIcon';
export { default as SubirIcon } from './SubirIcon';
export { default as TarjetaCreditoIcon } from './TarjetaCreditoIcon';
export { default as TecladoIcon } from './TecladoIcon';
export { default as TelefonoIcon } from './TelefonoIcon';
export { default as TortaIcon } from './TortaIcon';
export { default as UbicacionIcon } from './UbicacionIcon';
export { default as UsuarioIcon } from './UsuarioIcon';
export { default as VasosIcon } from './VasosIcon';

// Mapa de iconos para facilitar el acceso dinámico
export const IconMap = {
  'check': CheckIcon,
  'luna': LunaIcon,
  'abajo': AbajoIcon,
  'acciones': AccionesIcon,
  'actualizar': ActualizarIcon,
  'adelante': AdelanteIcon,
  'advertencia': AdvertenciaIcon,
  'ajustes': AjustesIcon,
  'apple-blanco': AppleBlancoIcon,
  'apple-negro': AppleNegroIcon,
  'arriba': ArribaIcon,
  'arroba': ArrobaIcon,
  'atras': AtrasIcon,
  'basurero': BasureroIcon,
  'bloqueado': BloqueadoIcon,
  'calendario': CalendarioIcon,
  'camara': CamaraIcon,
  'campana': CampanaIcon,
  'cantinero': CantineroIcon,
  'carpeta-mas': CarpetaMasIcon,
  'carrito': CarritoIcon,
  'casa': CasaIcon,
  'cerrar': CerrarIcon,
  'chrome': ChromeIcon,
  'clip': ClipIcon,
  'compartir-fuera': CompartirFueraIcon,
  'compartir': CompartirIcon,
  'configuraciones': ConfiguracionesIcon,
  'corazon': CorazonIcon,
  'correcto': CorrectoIcon,
  'cubiertos': CubiertosIcon,
  'cuidado': CuidadoIcon,
  'divisa': DivisaIcon,
  'editar': EditarIcon,
  'equipo': EquipoIcon,
  'estrella-amarilla': EstrellaAmarillaIcon,
  'estrella': EstrellaIcon,
  'eventos': EventosIcon,
  'facebook-color': FacebookColorIcon,
  'filtros': FiltrosIcon,
  'google-color': GoogleColorIcon,
  'grafico': GraficoIcon,
  'grilla': GrillaIcon,
  'guardar': GuardarIcon,
  'herramientas': HerramientasIcon,
  'idioma': IdiomaIcon,
  'imagen': ImagenIcon,
  'informacion': InformacionIcon,
  'instagram': InstagramIcon,
  'inventario': InventarioIcon,
  'lista': ListaIcon,
  'lupa': LupaIcon,
  'mas-horizontal': MasHorizontalIcon,
  'mas-usuario': MasUsuarioIcon,
  'mas-vertical': MasVerticalIcon,
  'mas': MasIcon,
  'menos': MenosIcon,
  'mensaje': MensajeIcon,
  'menu': MenuIcon,
  'mundo': MundoIcon,
  'ojo-cerrado': OjoCerradoIcon,
  'ojo': OjoIcon,
  'panel': PanelIcon,
  'pedidos': PedidosIcon,
  'pregunta': PreguntaIcon,
  'qr': QrIcon,
  'reloj': RelojIcon,
  'seguro': SeguroIcon,
  'signo-dolar': SignoDolarIcon,
  'social': SocialIcon,
  'sol': SolIcon,
  'subir': SubirIcon,
  'tarjeta-credito': TarjetaCreditoIcon,
  'teclado': TecladoIcon,
  'telefono': TelefonoIcon,
  'torta': TortaIcon,
  'ubicacion': UbicacionIcon,
  'usuario': UsuarioIcon,
  'vasos': VasosIcon,
};

// Lista de nombres de iconos disponibles
export const AVAILABLE_ICONS = Object.keys(IconMap);

// Type para nombres de iconos válidos
export type IconName = keyof typeof IconMap;
